webpackJsonp([106077160987319],{

/***/ 409:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyImage = function (_React$Component) {
	  _inherits(LazyImage, _React$Component);
	
	  function LazyImage(props) {
	    _classCallCheck(this, LazyImage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.realImgRef = null;
	    return _this;
	  }
	
	  LazyImage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // Load real image
	    var imgLoader = new Image();
	    imgLoader.src = this.props.src;
	    imgLoader.onload = function () {
	      var ratioWH = imgLoader.width / imgLoader.height;
	
	      _this2.imgElm.setAttribute('src', '' + _this2.props.src);
	
	      _this2.props.keepRatio && _this2.imgElm.setAttribute('height', '' + _this2.props.width / ratioWH);
	
	      _this2.imgElm.classList.add('' + _this2.props.effect);
	    };
	  };
	
	  LazyImage.prototype.render = function render() {
	    var _this3 = this;
	
	    var width = this.props.width || '100%';
	    var height = this.props.height || '100%';
	
	    return Glamor.createElement('img', {
	      src: this.props.placeHolder,
	      width: width,
	      height: height,
	      ref: function ref(imgElm) {
	        return _this3.imgElm = imgElm;
	      },
	      className: 'lazy-image'
	    });
	  };
	
	  return LazyImage;
	}(_react2.default.Component);
	
	exports.default = LazyImage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 1117:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAFRAQMAAACST0HKAAAAA1BMVEX///+nxBvIAAAAL0lEQVR42u3BMQEAAADCIPuntsROYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDiZAwAAYBhH+IAAAAASUVORK5CYII="

/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/profile_phamvanlam-com-co-dien.be33c8b1.jpg";

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _profile_phamvanlamComCoDien = __webpack_require__(1118);
	
	var _profile_phamvanlamComCoDien2 = _interopRequireDefault(_profile_phamvanlamComCoDien);
	
	var _widgetContainer = __webpack_require__(21);
	
	var _widgetContainer2 = _interopRequireDefault(_widgetContainer);
	
	var _lazyImage = __webpack_require__(289);
	
	var _lazyImage2 = _interopRequireDefault(_lazyImage);
	
	var _placeHolder = __webpack_require__(1117);
	
	var _placeHolder2 = _interopRequireDefault(_placeHolder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var seoTitle = "Gi\u1EDBi thi\u1EC7u - " + data.site.siteMetadata.title;
	  var url = data.site.siteMetadata.siteUrl + "/gioi-thieu/";
	
	  return Glamor.createElement(
	    "article",
	    null,
	    Glamor.createElement(_reactHelmet2.default, {
	      title: seoTitle,
	      meta: [{ name: 'description', content: "" + data.site.siteMetadata.description }, { name: 'keywords', content: "" + data.site.siteMetadata.keywords }]
	    }),
	    Glamor.createElement(
	      "h1",
	      null,
	      "Gi\u1EDBi thi\u1EC7u"
	    ),
	    Glamor.createElement(
	      _widgetContainer2.default,
	      null,
	      Glamor.createElement(
	        "p",
	        null,
	        "Xin ch\xE0o c\xE1c b\u1EA1n! T\xF4i l\xE0 Ph\u1EA1m V\u0103n L\xE2m, c\u1EF1u sinh vi\xEAn \u0110\u1EA1i h\u1ECDc B\xE1ch Khoa H\xE0 N\u1ED9i chuy\xEAn ng\xE0nh \u0110i\u1EC7n t\u1EED \u2013 Vi\u1EC5n th\xF4ng. Hi\u1EC7n t\u1EA1i, t\xF4i \u0111ang l\xE0m vi\u1EC7c t\u1EA1i SVMC \u2013 trung t\xE2m nghi\xEAn c\u1EE9u v\xE0 ph\xE1t tri\u1EC3n \u0111i\u1EC7n tho\u1EA1i di \u0111\u1ED9ng Samsung t\u1EA1i Vi\u1EC7t Nam."
	      ),
	      Glamor.createElement(
	        "div",
	        { style: { display: "flex", justifyContent: "center" } },
	        Glamor.createElement(_lazyImage2.default, {
	          placeHolder: _placeHolder2.default,
	          src: _profile_phamvanlamComCoDien2.default,
	          width: "252",
	          height: "auto",
	          effect: "opacity",
	          alt: "lam pham profile image",
	          keepRatio: true
	        })
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "T\xF4i l\u1EADp n\xEAn trang web n\xE0y v\u1EDBi m\u1EE5c \u0111\xEDch chia s\u1EBB nh\u1EEFng ki\u1EBFn th\u1EE9c v\xE0 kinh nghi\u1EC7m c\u1EE7a b\u1EA3n th\xE2n v\u1EC1 c\xE1c thu\u1EADt to\xE1n v\xE0 l\u1EDDi gi\u1EA3i c\xE1c b\xE0i to\xE1n c\u01A1 b\u1EA3n m\xE0 t\xF4i \u0111\xE3 th\u1EF1c h\xE0nh tr\xEAn c\xE1c trang nh\u01B0 spoj.com, acm.timus.ru,..."
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "R\u1EA5t mong nh\u1EADn \u0111\u01B0\u1EE3c s\u1EF1 \u1EE7ng h\u1ED9 v\xE0 \u0111\xF3ng g\xF3p \xFD ki\u1EBFn c\u1EE7a c\xE1c b\u1EA1n \u0111\u1EC3 trang web ng\xE0y c\xE0ng ho\xE0n thi\u1EC7n h\u01A1n. Qua \u0111\xF3, t\xF4i c\xF3 th\xEAm nhi\u1EC1u \u0111\u1ED9ng l\u1EF1c \u0111\u1EC3 ph\xE1t tri\u1EC3n trang web n\xE0y."
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "Xin ch\xE2n th\xE0nh c\xE1m \u01A1n!"
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "Ph\u1EA1m V\u0103n L\xE2m."
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gioi-thieu-js-5669c7898ac73f360248.js